// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../css-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[6].use[1]!../../postcss-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[6].use[2]!./colors.module.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../css-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[6].use[1]!../../postcss-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[6].use[2]!./variables.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  ======================

    - *** NOTICE ***
    - This file will be imported into lots of pages and components built with React and needs to be kept as lean as possible
    - *** NOTICE ***

    - To use the colors in this file, place this import statement at the top of the component's CSS file
    - @import '../path/to/styles/utility.module.css';

    - Transition docs:
    - As new React pages and components are built using pre-existing styles, on an as needed basis...
    - > port style rules into here from the legacy UX repo's app.utility.module.css file
    - If you're running the UX repo locally, you can see what file the style rule is coming from in the dev tools

    ====================== */

/* Wrapping CSS in the :global pseudo selector tells CSS Modules not to change the class names */
.clearfix {
    *zoom: 1;
}

.clearfix:before, .clearfix:after {
    display: table;
    line-height: 0;
    content: "";
}

.clearfix:after {
    clear: both;
}

.textCenter {
    text-align: center;
}

.textLeft {
    text-align: left;
}

.textRight {
    text-align: right;
}

.pullLeft {
    float: left;
}

.pullRight {
    float: right;
}

.truncate {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* spacing utility classes */
.marXS {
    margin: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingXS"]};
}

.marSM {
    margin: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingSM"]};
}

.marMD {
    margin: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingMD"]};
}

.marLG {
    margin: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingLG"]};
}

.marXL {
    margin: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingXL"]};
}

.marXAxisXS {
    margin-left: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingXS"]};
    margin-right: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingXS"]};
}

.marXAxisSM {
    margin-left: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingSM"]};
    margin-right: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingSM"]};
}

.marXAxisMD {
    margin-left: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingMD"]};
    margin-right: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingMD"]};
}

.marXAxisLG {
    margin-left: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingLG"]};
    margin-right: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingLG"]};
}

.marXAxisXL {
    margin-left: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingXL"]};
    margin-right: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingXL"]};
}

.marYAxisXS {
    margin-top: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingXS"]};
    margin-bottom: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingXS"]};
}

.marYAxisSM {
    margin-top: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingSM"]};
    margin-bottom: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingSM"]};
}

.marYAxisMD {
    margin-top: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingMD"]};
    margin-bottom: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingMD"]};
}

.marYAxisLG {
    margin-top: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingLG"]};
    margin-bottom: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingLG"]};
}

.marYAxisXL {
    margin-top: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingXL"]};
    margin-bottom: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingXL"]};
}

.marTopNO {
    margin-top: 0;
}

.marTopXS {
    margin-top: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingXS"]};
}

.marTopSM {
    margin-top: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingSM"]};
}

.marTopMD {
    margin-top: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingMD"]};
}

.marTopLG {
    margin-top: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingLG"]};
}

.marTopXL {
    margin-top: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingXL"]};
}

.marRightNO {
    margin-right: 0;
}

.marRightXS {
    margin-right: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingXS"]};
}

.marRightSM {
    margin-right: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingSM"]};
}

.marRightMD {
    margin-right: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingMD"]};
}

.marRightLG {
    margin-right: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingLG"]};
}

.marRightXL {
    margin-right: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingXL"]};
}

.marBottomNO {
    margin-bottom: 0;
}

.marBottomXS {
    margin-bottom: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingXS"]};
}

.marBottomSM {
    margin-bottom: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingSM"]};
}

.marBottomMD {
    margin-bottom: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingMD"]};
}

.marBottomLG {
    margin-bottom: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingLG"]};
}

.marBottomXL {
    margin-bottom: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingXL"]};
}

.marLeftNO {
    margin-left: 0;
}

.marLeftXS {
    margin-left: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingXS"]};
}

.marLeftSM {
    margin-left: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingSM"]};
}

.marLeftMD {
    margin-left: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingMD"]};
}

.marLeftLG {
    margin-left: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingLG"]};
}

.marLeftXL {
    margin-left: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingXL"]};
}

.padXS {
    padding: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingXS"]};
}

.padSM {
    padding: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingSM"]};
}

.padMD {
    padding: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingMD"]};
}

.padLG {
    padding: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingLG"]};
}

.padXL {
    padding: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingXL"]};
}

.padXAxisXS {
    padding-left: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingXS"]};
    padding-right: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingXS"]};
}

.padXAxisSM {
    padding-left: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingSM"]};
    padding-right: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingSM"]};
}

.padXAxisMD {
    padding-left: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingMD"]};
    padding-right: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingMD"]};
}

.padXAxisLG {
    padding-left: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingLG"]};
    padding-right: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingLG"]};
}

.padXAxisXL {
    padding-left: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingXL"]};
    padding-right: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingXL"]};
}

.padYAxisXS {
    padding-top: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingXS"]};
    padding-bottom: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingXS"]};
}

.padYAxisSM {
    padding-top: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingSM"]};
    padding-bottom: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingSM"]};
}

.padYAxisMD {
    padding-top: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingMD"]};
    padding-bottom: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingMD"]};
}

.padYAxisLG {
    padding-top: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingLG"]};
    padding-bottom: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingLG"]};
}

.padYAxisXL {
    padding-top: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingXL"]};
    padding-bottom: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingXL"]};
}

.padTopNO {
    padding-top: 0;
}

.padTopXS {
    padding-top: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingXS"]};
}

.padTopSM {
    padding-top: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingSM"]};
}

.padTopMD {
    padding-top: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingMD"]};
}

.padTopLG {
    padding-top: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingLG"]};
}

.padTopXL {
    padding-top: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingXL"]};
}

.padRightNO {
    padding-right: 0;
}

.padRightXS {
    padding-right: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingXS"]};
}

.padRightSM {
    padding-right: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingSM"]};
}

.padRightMD {
    padding-right: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingMD"]};
}

.padRightLG {
    padding-right: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingLG"]};
}

.padRightXL {
    padding-right: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingXL"]};
}

.padBottomNO {
    padding-bottom: 0;
}

.padBottomXS {
    padding-bottom: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingXS"]};
}

.padBottomSM {
    padding-bottom: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingSM"]};
}

.padBottomMD {
    padding-bottom: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingMD"]};
}

.padBottomLG {
    padding-bottom: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingLG"]};
}

.padBottomXL {
    padding-bottom: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingXL"]};
}

.padLeftNO {
    padding-left: 0;
}

.padLeftXS {
    padding-left: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingXS"]};
}

.padLeftSM {
    padding-left: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingSM"]};
}

.padLeftMD {
    padding-left: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingMD"]};
}

.padLeftLG {
    padding-left: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingLG"]};
}

.padLeftXL {
    padding-left: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingXL"]};
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/styles/utility.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;4BAc4B;;AAK5B,gGAAgG;AAChG;KACI,OAAQ;AACZ;;AAEA;IAEI,cAAc;IACd,cAAc;IACd,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,4BAA4B;AAC5B;IACI,oDAAiB;AACrB;;AAEA;IACI,oDAAiB;AACrB;;AAEA;IACI,oDAAiB;AACrB;;AAEA;IACI,oDAAiB;AACrB;;AAEA;IACI,oDAAiB;AACrB;;AAEA;IACI,yDAAsB;IACtB,0DAAuB;AAC3B;;AAEA;IACI,yDAAsB;IACtB,0DAAuB;AAC3B;;AAEA;IACI,yDAAsB;IACtB,0DAAuB;AAC3B;;AAEA;IACI,yDAAsB;IACtB,0DAAuB;AAC3B;;AAEA;IACI,yDAAsB;IACtB,0DAAuB;AAC3B;;AAEA;IACI,wDAAqB;IACrB,2DAAwB;AAC5B;;AAEA;IACI,wDAAqB;IACrB,2DAAwB;AAC5B;;AAEA;IACI,wDAAqB;IACrB,2DAAwB;AAC5B;;AAEA;IACI,wDAAqB;IACrB,2DAAwB;AAC5B;;AAEA;IACI,wDAAqB;IACrB,2DAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wDAAqB;AACzB;;AAEA;IACI,wDAAqB;AACzB;;AAEA;IACI,wDAAqB;AACzB;;AAEA;IACI,wDAAqB;AACzB;;AAEA;IACI,wDAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0DAAuB;AAC3B;;AAEA;IACI,0DAAuB;AAC3B;;AAEA;IACI,0DAAuB;AAC3B;;AAEA;IACI,0DAAuB;AAC3B;;AAEA;IACI,0DAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2DAAwB;AAC5B;;AAEA;IACI,2DAAwB;AAC5B;;AAEA;IACI,2DAAwB;AAC5B;;AAEA;IACI,2DAAwB;AAC5B;;AAEA;IACI,2DAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yDAAsB;AAC1B;;AAEA;IACI,yDAAsB;AAC1B;;AAEA;IACI,yDAAsB;AAC1B;;AAEA;IACI,yDAAsB;AAC1B;;AAEA;IACI,yDAAsB;AAC1B;;AAEA;IACI,qDAAkB;AACtB;;AAEA;IACI,qDAAkB;AACtB;;AAEA;IACI,qDAAkB;AACtB;;AAEA;IACI,qDAAkB;AACtB;;AAEA;IACI,qDAAkB;AACtB;;AAEA;IACI,0DAAuB;IACvB,2DAAwB;AAC5B;;AAEA;IACI,0DAAuB;IACvB,2DAAwB;AAC5B;;AAEA;IACI,0DAAuB;IACvB,2DAAwB;AAC5B;;AAEA;IACI,0DAAuB;IACvB,2DAAwB;AAC5B;;AAEA;IACI,0DAAuB;IACvB,2DAAwB;AAC5B;;AAEA;IACI,yDAAsB;IACtB,4DAAyB;AAC7B;;AAEA;IACI,yDAAsB;IACtB,4DAAyB;AAC7B;;AAEA;IACI,yDAAsB;IACtB,4DAAyB;AAC7B;;AAEA;IACI,yDAAsB;IACtB,4DAAyB;AAC7B;;AAEA;IACI,yDAAsB;IACtB,4DAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yDAAsB;AAC1B;;AAEA;IACI,yDAAsB;AAC1B;;AAEA;IACI,yDAAsB;AAC1B;;AAEA;IACI,yDAAsB;AAC1B;;AAEA;IACI,yDAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2DAAwB;AAC5B;;AAEA;IACI,2DAAwB;AAC5B;;AAEA;IACI,2DAAwB;AAC5B;;AAEA;IACI,2DAAwB;AAC5B;;AAEA;IACI,2DAAwB;AAC5B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4DAAyB;AAC7B;;AAEA;IACI,4DAAyB;AAC7B;;AAEA;IACI,4DAAyB;AAC7B;;AAEA;IACI,4DAAyB;AAC7B;;AAEA;IACI,4DAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0DAAuB;AAC3B;;AAEA;IACI,0DAAuB;AAC3B;;AAEA;IACI,0DAAuB;AAC3B;;AAEA;IACI,0DAAuB;AAC3B;;AAEA;IACI,0DAAuB;AAC3B","sourcesContent":["/*  ======================\n\n    - *** NOTICE ***\n    - This file will be imported into lots of pages and components built with React and needs to be kept as lean as possible\n    - *** NOTICE ***\n\n    - To use the colors in this file, place this import statement at the top of the component's CSS file\n    - @import '../path/to/styles/utility.module.css';\n\n    - Transition docs:\n    - As new React pages and components are built using pre-existing styles, on an as needed basis...\n    - > port style rules into here from the legacy UX repo's app.utility.module.css file\n    - If you're running the UX repo locally, you can see what file the style rule is coming from in the dev tools\n\n    ====================== */\n\n@value color_115 from './colors.module.css';\n@value (spacingXS, spacingSM, spacingMD, spacingLG, spacingXL) from './variables.module.css';\n\n/* Wrapping CSS in the :global pseudo selector tells CSS Modules not to change the class names */\n:global .clearfix {\n    *zoom: 1;\n}\n\n:global .clearfix:before,\n:global .clearfix:after {\n    display: table;\n    line-height: 0;\n    content: \"\";\n}\n\n:global .clearfix:after {\n    clear: both;\n}\n\n:global .textCenter {\n    text-align: center;\n}\n\n:global .textLeft {\n    text-align: left;\n}\n\n:global .textRight {\n    text-align: right;\n}\n\n:global .pullLeft {\n    float: left;\n}\n\n:global .pullRight {\n    float: right;\n}\n\n:global .truncate {\n    display: block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n/* spacing utility classes */\n:global .marXS {\n    margin: spacingXS;\n}\n\n:global .marSM {\n    margin: spacingSM;\n}\n\n:global .marMD {\n    margin: spacingMD;\n}\n\n:global .marLG {\n    margin: spacingLG;\n}\n\n:global .marXL {\n    margin: spacingXL;\n}\n\n:global .marXAxisXS {\n    margin-left: spacingXS;\n    margin-right: spacingXS;\n}\n\n:global .marXAxisSM {\n    margin-left: spacingSM;\n    margin-right: spacingSM;\n}\n\n:global .marXAxisMD {\n    margin-left: spacingMD;\n    margin-right: spacingMD;\n}\n\n:global .marXAxisLG {\n    margin-left: spacingLG;\n    margin-right: spacingLG;\n}\n\n:global .marXAxisXL {\n    margin-left: spacingXL;\n    margin-right: spacingXL;\n}\n\n:global .marYAxisXS {\n    margin-top: spacingXS;\n    margin-bottom: spacingXS;\n}\n\n:global .marYAxisSM {\n    margin-top: spacingSM;\n    margin-bottom: spacingSM;\n}\n\n:global .marYAxisMD {\n    margin-top: spacingMD;\n    margin-bottom: spacingMD;\n}\n\n:global .marYAxisLG {\n    margin-top: spacingLG;\n    margin-bottom: spacingLG;\n}\n\n:global .marYAxisXL {\n    margin-top: spacingXL;\n    margin-bottom: spacingXL;\n}\n\n:global .marTopNO {\n    margin-top: 0;\n}\n\n:global .marTopXS {\n    margin-top: spacingXS;\n}\n\n:global .marTopSM {\n    margin-top: spacingSM;\n}\n\n:global .marTopMD {\n    margin-top: spacingMD;\n}\n\n:global .marTopLG {\n    margin-top: spacingLG;\n}\n\n:global .marTopXL {\n    margin-top: spacingXL;\n}\n\n:global .marRightNO {\n    margin-right: 0;\n}\n\n:global .marRightXS {\n    margin-right: spacingXS;\n}\n\n:global .marRightSM {\n    margin-right: spacingSM;\n}\n\n:global .marRightMD {\n    margin-right: spacingMD;\n}\n\n:global .marRightLG {\n    margin-right: spacingLG;\n}\n\n:global .marRightXL {\n    margin-right: spacingXL;\n}\n\n:global .marBottomNO {\n    margin-bottom: 0;\n}\n\n:global .marBottomXS {\n    margin-bottom: spacingXS;\n}\n\n:global .marBottomSM {\n    margin-bottom: spacingSM;\n}\n\n:global .marBottomMD {\n    margin-bottom: spacingMD;\n}\n\n:global .marBottomLG {\n    margin-bottom: spacingLG;\n}\n\n:global .marBottomXL {\n    margin-bottom: spacingXL;\n}\n\n:global .marLeftNO {\n    margin-left: 0;\n}\n\n:global .marLeftXS {\n    margin-left: spacingXS;\n}\n\n:global .marLeftSM {\n    margin-left: spacingSM;\n}\n\n:global .marLeftMD {\n    margin-left: spacingMD;\n}\n\n:global .marLeftLG {\n    margin-left: spacingLG;\n}\n\n:global .marLeftXL {\n    margin-left: spacingXL;\n}\n\n:global .padXS {\n    padding: spacingXS;\n}\n\n:global .padSM {\n    padding: spacingSM;\n}\n\n:global .padMD {\n    padding: spacingMD;\n}\n\n:global .padLG {\n    padding: spacingLG;\n}\n\n:global .padXL {\n    padding: spacingXL;\n}\n\n:global .padXAxisXS {\n    padding-left: spacingXS;\n    padding-right: spacingXS;\n}\n\n:global .padXAxisSM {\n    padding-left: spacingSM;\n    padding-right: spacingSM;\n}\n\n:global .padXAxisMD {\n    padding-left: spacingMD;\n    padding-right: spacingMD;\n}\n\n:global .padXAxisLG {\n    padding-left: spacingLG;\n    padding-right: spacingLG;\n}\n\n:global .padXAxisXL {\n    padding-left: spacingXL;\n    padding-right: spacingXL;\n}\n\n:global .padYAxisXS {\n    padding-top: spacingXS;\n    padding-bottom: spacingXS;\n}\n\n:global .padYAxisSM {\n    padding-top: spacingSM;\n    padding-bottom: spacingSM;\n}\n\n:global .padYAxisMD {\n    padding-top: spacingMD;\n    padding-bottom: spacingMD;\n}\n\n:global .padYAxisLG {\n    padding-top: spacingLG;\n    padding-bottom: spacingLG;\n}\n\n:global .padYAxisXL {\n    padding-top: spacingXL;\n    padding-bottom: spacingXL;\n}\n\n:global .padTopNO {\n    padding-top: 0;\n}\n\n:global .padTopXS {\n    padding-top: spacingXS;\n}\n\n:global .padTopSM {\n    padding-top: spacingSM;\n}\n\n:global .padTopMD {\n    padding-top: spacingMD;\n}\n\n:global .padTopLG {\n    padding-top: spacingLG;\n}\n\n:global .padTopXL {\n    padding-top: spacingXL;\n}\n\n:global .padRightNO {\n    padding-right: 0;\n}\n\n:global .padRightXS {\n    padding-right: spacingXS;\n}\n\n:global .padRightSM {\n    padding-right: spacingSM;\n}\n\n:global .padRightMD {\n    padding-right: spacingMD;\n}\n\n:global .padRightLG {\n    padding-right: spacingLG;\n}\n\n:global .padRightXL {\n    padding-right: spacingXL;\n}\n\n:global .padBottomNO {\n    padding-bottom: 0;\n}\n\n:global .padBottomXS {\n    padding-bottom: spacingXS;\n}\n\n:global .padBottomSM {\n    padding-bottom: spacingSM;\n}\n\n:global .padBottomMD {\n    padding-bottom: spacingMD;\n}\n\n:global .padBottomLG {\n    padding-bottom: spacingLG;\n}\n\n:global .padBottomXL {\n    padding-bottom: spacingXL;\n}\n\n:global .padLeftNO {\n    padding-left: 0;\n}\n\n:global .padLeftXS {\n    padding-left: spacingXS;\n}\n\n:global .padLeftSM {\n    padding-left: spacingSM;\n}\n\n:global .padLeftMD {\n    padding-left: spacingMD;\n}\n\n:global .padLeftLG {\n    padding-left: spacingLG;\n}\n\n:global .padLeftXL {\n    padding-left: spacingXL;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color_115": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color_115"]}`,
	"spacingXS": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingXS"]}`,
	"spacingSM": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingSM"]}`,
	"spacingMD": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingMD"]}`,
	"spacingLG": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingLG"]}`,
	"spacingXL": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["spacingXL"]}`,
	"clearfix": `clearfix`,
	"textCenter": `textCenter`,
	"textLeft": `textLeft`,
	"textRight": `textRight`,
	"pullLeft": `pullLeft`,
	"pullRight": `pullRight`,
	"truncate": `truncate`,
	"marXS": `marXS`,
	"marSM": `marSM`,
	"marMD": `marMD`,
	"marLG": `marLG`,
	"marXL": `marXL`,
	"marXAxisXS": `marXAxisXS`,
	"marXAxisSM": `marXAxisSM`,
	"marXAxisMD": `marXAxisMD`,
	"marXAxisLG": `marXAxisLG`,
	"marXAxisXL": `marXAxisXL`,
	"marYAxisXS": `marYAxisXS`,
	"marYAxisSM": `marYAxisSM`,
	"marYAxisMD": `marYAxisMD`,
	"marYAxisLG": `marYAxisLG`,
	"marYAxisXL": `marYAxisXL`,
	"marTopNO": `marTopNO`,
	"marTopXS": `marTopXS`,
	"marTopSM": `marTopSM`,
	"marTopMD": `marTopMD`,
	"marTopLG": `marTopLG`,
	"marTopXL": `marTopXL`,
	"marRightNO": `marRightNO`,
	"marRightXS": `marRightXS`,
	"marRightSM": `marRightSM`,
	"marRightMD": `marRightMD`,
	"marRightLG": `marRightLG`,
	"marRightXL": `marRightXL`,
	"marBottomNO": `marBottomNO`,
	"marBottomXS": `marBottomXS`,
	"marBottomSM": `marBottomSM`,
	"marBottomMD": `marBottomMD`,
	"marBottomLG": `marBottomLG`,
	"marBottomXL": `marBottomXL`,
	"marLeftNO": `marLeftNO`,
	"marLeftXS": `marLeftXS`,
	"marLeftSM": `marLeftSM`,
	"marLeftMD": `marLeftMD`,
	"marLeftLG": `marLeftLG`,
	"marLeftXL": `marLeftXL`,
	"padXS": `padXS`,
	"padSM": `padSM`,
	"padMD": `padMD`,
	"padLG": `padLG`,
	"padXL": `padXL`,
	"padXAxisXS": `padXAxisXS`,
	"padXAxisSM": `padXAxisSM`,
	"padXAxisMD": `padXAxisMD`,
	"padXAxisLG": `padXAxisLG`,
	"padXAxisXL": `padXAxisXL`,
	"padYAxisXS": `padYAxisXS`,
	"padYAxisSM": `padYAxisSM`,
	"padYAxisMD": `padYAxisMD`,
	"padYAxisLG": `padYAxisLG`,
	"padYAxisXL": `padYAxisXL`,
	"padTopNO": `padTopNO`,
	"padTopXS": `padTopXS`,
	"padTopSM": `padTopSM`,
	"padTopMD": `padTopMD`,
	"padTopLG": `padTopLG`,
	"padTopXL": `padTopXL`,
	"padRightNO": `padRightNO`,
	"padRightXS": `padRightXS`,
	"padRightSM": `padRightSM`,
	"padRightMD": `padRightMD`,
	"padRightLG": `padRightLG`,
	"padRightXL": `padRightXL`,
	"padBottomNO": `padBottomNO`,
	"padBottomXS": `padBottomXS`,
	"padBottomSM": `padBottomSM`,
	"padBottomMD": `padBottomMD`,
	"padBottomLG": `padBottomLG`,
	"padBottomXL": `padBottomXL`,
	"padLeftNO": `padLeftNO`,
	"padLeftXS": `padLeftXS`,
	"padLeftSM": `padLeftSM`,
	"padLeftMD": `padLeftMD`,
	"padLeftLG": `padLeftLG`,
	"padLeftXL": `padLeftXL`
};
export default ___CSS_LOADER_EXPORT___;
